import React from 'react'
import { Edit } from 'react-admin'

import CompetitionsForm from './form'

export const ProceduresEdit = (props) => (
  <Edit undoable={false} {...props}>
    <CompetitionsForm {...props} />
  </Edit>
)

export default ProceduresEdit
